import React, { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import Logo from "./Logo";

const KEY = "fesx_age_verified_v1";

const AgeVerificationModal = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const ok = sessionStorage.getItem(KEY);
    if (!ok) setShow(true);
  }, []);

  const confirm = () => {
    sessionStorage.setItem(KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/70 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl overflow-hidden fesx-fade-up">
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-5 flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-white/15 flex items-center justify-center">
            <ShieldAlert className="h-6 w-6 text-white" />
          </div>
          <div className="text-white">
            <div className="text-xs font-semibold uppercase tracking-widest text-blue-200">Research Use Only</div>
            <div className="font-display font-bold text-lg">Confirm your age</div>
          </div>
        </div>
        <div className="px-6 py-6">
          <div className="mb-4 flex justify-center">
            <Logo size="lg" />
          </div>
          <p className="text-sm text-slate-600 leading-relaxed text-center">
            All products are supplied strictly for <span className="font-semibold text-slate-800">laboratory and research use only</span> —
            not for human or veterinary use. By entering, you confirm you are <span className="font-semibold text-slate-800">18 or older</span> and
            agree to our Terms &amp; Conditions.
          </p>
          <button
            onClick={confirm}
            className="mt-6 w-full rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 transition-colors active:scale-[0.99]"
          >
            I'm 18 or older — Enter
          </button>
          <a
            href="https://www.google.com"
            className="mt-3 block text-center text-xs text-slate-400 hover:text-slate-600"
          >
            Under 18? Leave this site
          </a>
        </div>
      </div>
    </div>
  );
};

export default AgeVerificationModal;
